export default __webpack_public_path__ + "media/react/pages/payment_flows/add_ons/assets/admissions/headshot_brittny-9090bdb31fff376958aa65f22b6819e5.jpg";